import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import EndCallButton from 'components/InCall/InCallFooterButtons/EndCallButton';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { openInCallModal } from 'actions/InCallModal';
import { callActions } from '@lifesize/nucleus';
import Modals from 'constants/Modals';

const mapStateToProps = (state, ownProps) => {
  const canKickAll = ownProps.canKickAll;
  return {
    ...ownProps,
    canKickAll
  };
};

const mapDispatchToProps = dispatch => ({
  onClick: canKickAll => {
    canKickAll
      ? dispatch(openInCallModal(Modals.endCallForAll))
      : dispatch(callActions.end());
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onClick: () => dispatchProps.onClick(stateProps.canKickAll)
});

const ConnectedComponent = injectIntl(connect(mapStateToProps, mapDispatchToProps, mergeProps)(EndCallButton));

const FunctionalComponent = (props) => {
  const canKickAll = hooks.useCanCurrentUserKickAll();

  return (
    <ConnectedComponent
      {...props}
      canKickAll={canKickAll}
    />
  );
}

export default FunctionalComponent;
